module.exports = __webpack_public_path__ + "img/4.b042fd1a.jpg";